import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/Home.vue'

import Layout from '@/components/Layout/index';
import ContentView from '@/view/common/contentView.vue';
// import Index from "@/view/apply/index.vue";
// import EmailForm from "@/view/apply/child/emailForm.vue";
// import SelectPage from "@/view/apply/child/selectPage.vue";
// import PersonalInfo from "@/view/apply/child/personalInfo.vue";
// import EmailVerify from "@/view/common/emailVerify.vue";
// import LiveEmployment from "@/view/apply/child/liveEmployment.vue";
// import LiveEmployment2 from "@/view/apply/child/liveEmployment.vue";
// import Declaration from "@/view/apply/child/declaration.vue";
// import Information from "@/view/apply/child/information.vue";
// import FileIndex from "@/view/upload/index.vue";
// import FileIndex2 from "@/view/upload/index.vue";
// import ApplySuccess from "@/view/common/applySuccess.vue";
// import Terms from "@/view/apply/child/terms.vue";
// // 查询需要的页面
// import QueryCondiction from "@/view/query/child/condiction.vue";
// import QueryResult from "@/view/query/child/result.vue";

// <!-- 首页 -->
// <index v-if="setepInfoData.currentOperateName == 'home'" />
// <!-- 邮箱输入 -->
// <email-form v-if="setepInfoData.currentOperateName == 'emailQuery'" />
// <!-- 选择申请方式 -->
// <select-page v-if="setepInfoData.currentOperateName == 'selectPage'" />
// <!-- 个人信息表单 -->
// <personal-info v-if="setepInfoData.currentOperateName == 'personalInfo'" />
// <!-- 邮箱验证 -->
// <email-verify v-if="setepInfoData.currentOperateName == 'emailVerify'" />
// <!-- 住屋、生活及工作資料 -->
// <live-employment v-if="setepInfoData.currentOperateName == 'liveEmployment'" />
// <!-- 住屋、生活及工作資料[二人申請] -->
// <live-employment2 v-if="setepInfoData.currentOperateName == 'liveEmployment2'" />
// <!-- 申請資格聲明申請資格聲明 -->
// <declaration v-if="setepInfoData.currentOperateName == 'declaration'" />
// <!-- 个人资料预览 -->
// <information v-if="setepInfoData.currentOperateName == 'informationPreview'" />
// <!-- 申報及上傳檔案 -->
// <file-index v-if="setepInfoData.currentOperateName == 'fileIndex'" />
// <!-- 申報及上傳檔案 [二人申請]-->
// <file-index2 v-if="setepInfoData.currentOperateName == 'fileIndex2'" />
// <!-- 聲明、條款及細則 -->
// <terms v-if="setepInfoData.currentOperateName == 'terms'" />
// <!-- 申请成功 -->
// <apply-success v-if="setepInfoData.currentOperateName == 'applySuccess'" />
// <!-- 查询申请-输入条件 -->
// <query-condiction v-if="setepInfoData.currentOperateName == 'queryCondiction'" />

// <!-- 查询条件展示 -->
// <query-result v-if="setepInfoData.currentOperateName == 'queryResult'" />



Vue.use(Router)
export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({
    y: 0
  }),
  //   routes: [{
  //     path: '/',
  //     component: () => import('@/components/Layout/index'), // 这里配置左边步骤
  //     children: [{
  //         path: 'index',
  //         name: 'index',
  //         components: {
  //           formData: () => import('@/view/apply/index.vue')
  //         }
  //       },
  //       {
  //         path: 'emailQuery',
  //         name: 'emailQuery',
  //         components: {
  //           formData: () => import('@/view/apply/child/emailForm.vue')
  //         }
  //       }
  //     ],
  //   }]
  // })

  routes: [{
      path: '/',
      name: 'Home',
      component: Home,
    }, {
      path: '/content/:code',
      name: 'ContentView',
      component: ContentView
    },
    {
      path: '*',
      component: (resolve) => require(['@/view/error/404'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js